import { useCallback, useState } from 'react'
import UserService2 from '@/services/UserService2'

export default function useUsers2Data() {
	const limit = 1000
	const sortColumn = '_id'
	const sortDirection = 'desc'
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [creating, setCreating] = useState(false)
	const [updating, setUpdating] = useState(false)
	const [removing, setRemoving] = useState(false)
	const [error, setError] = useState(null)
	const [totalCount, setTotalCount] = useState(0)

	const loadData = useCallback(async () => {
		setLoading(true)
		setError(null)

		try {
			const result = await UserService2.getWithFilters({ limit, sortColumn, sortDirection, filters: {} })

			if (result.error) {
				setError(result.error)
				setData([])
				setTotalCount(0)
				return
			}

			setData(result.data)
			setTotalCount(result.totalCount)
		} catch (error) {
			setError(error.message || 'Failed to fetch records')
			setData([])
			setTotalCount(0)
		} finally {
			setLoading(false)
		}
	}, [])

	const clearError = useCallback(() => {
		setError(null)
	}, [])

	const create = useCallback(async newRecord => {
		setCreating(true)
		setError(null)

		try {
			const result = await UserService2.create(newRecord)
			if (result.error) {
				setError(result.error)
				return false
			}

			await loadData()
			return true
		} catch (error) {
			setError(error.message || 'Failed to create record')
			return false
		} finally {
			setCreating(false)
		}
	}, [loadData])

	const remove = useCallback(async id => {
		setRemoving(true)
		setError(null)

		try {
			const result = await UserService2.delete(id)
			if (result.error) {
				setError(result.error)
				return false
			}

			await loadData()
			return true
		} catch (error) {
			setError(error.message || 'Failed to delete record')
			return false
		} finally {
			setRemoving(false)
		}
	}, [loadData])

	const update = useCallback(async (id, updatedRecord) => {
		setUpdating(true)
		setError(null)

		try {
			const result = await UserService2.update(id, updatedRecord)
			if (result.error) {
				setError(result.error)
				return false
			}

			await loadData()
			return true
		} catch (error) {
			setError(error.message || 'Failed to update record')
			return false
		} finally {
			setUpdating(false)
		}
	}, [loadData])

	return {
		data,
		totalCount,
		loading,
		creating,
		updating,
		removing,
		error,
		clearError,
		sortColumn,
		sortDirection,
		limit,
		loadData,
		create,
		remove,
		update,
	}
}
